import styled from "styled-components";
import { desktop, mobile, NotMobile, tablet } from "components/templates/Breakpoints";
import { color, fonts } from "@styles";
import { Form } from "@unform/web";

export const Asterisk = styled.span`
  &:before {
    content: "*";
    color: #ff6666;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;

  ${mobile} {
    grid-template-columns: 1fr;
  }
`;

export const Li = styled.li<{ color?: string }>`
  font-family: ${fonts.body};
  font-size: 1.25rem;
  line-height: 2rem;
  letter-spacing: 0.075rem;
  color: ${(p) => p.color || color.B1100};
  padding-top: 1.25rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

export const LogoFlex = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 3rem;
  row-gap: 1.5rem;
  margin: 1rem 0;
  justify-content: center;
`;

export const Anchor = styled.a`
  text-decoration: underline;
  color: ${color.P100};
`;

export const YugiImageContainer = styled.div`
  text-align: right;

  ${mobile} {
    text-align: left;
    margin-bottom: -5rem;
  }

  img {
    max-width: 100%;
  }
`;

export const Grid2 = styled.div<{ gap?: string }>`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${(p) => p.gap || "8rem"};

  ${mobile} {
    grid-template-columns: 1fr;
    row-gap: 0;
  }
`;

export const FormContainer = styled(Form)`
  background: ${color.B210};
  border: 2px solid ${color.B240};
  border-radius: 8px;
  box-shadow: 0.5rem 0.5rem 0px rgba(92, 87, 87, 0.08);
  padding: 2.5rem;

  ${mobile} {
    padding: 1.25rem;
    transform: translateY(0);
  }

  ${desktop} {
    transform: translateY(-5rem);
    margin-bottom: -5rem;
  }
`;

export const Relative = styled.div`
  position: relative;
`;
